import * as tslib_1 from "tslib";
import emptyFolder from './emptyFolder';
import { getFocusedFilterForTable, getViewFilterForTable } from 'owa-mail-list-store';
import folderStore from 'owa-folders';
import { action, select } from 'satcheljs/lib/legacy';
export default action('emptyTableView')(select({
    folderToBeEmptied: function (tableViewToBeEmptied) {
        return folderStore.folderTable.get(tableViewToBeEmptied.tableQuery.folderId);
    },
})(function emptyTableView(tableViewToBeEmptied, isExplicitSoftDelete, actionSource, rowKeysToExclude, state) {
    var folderToBeEmptied = state.folderToBeEmptied;
    // User server folder id for empty table view if it's not deleteditems or junkemail or dumpster.
    // For deleteditems or junkemail or dumpster, they don't support delete all with a viewFilter specified.
    if (folderToBeEmptied.DistinguishedFolderId === 'recoverableitemsdeletions' ||
        folderToBeEmptied.DistinguishedFolderId === 'deleteditems' ||
        folderToBeEmptied.DistinguishedFolderId === 'junkemail') {
        emptyFolder(folderToBeEmptied, -1 /* None */, 'All', isExplicitSoftDelete, actionSource, rowKeysToExclude, tableViewToBeEmptied.selectAllModeTimeStamp, tableViewToBeEmptied.id);
    }
    else {
        // Copy properties from folderToBeEmptied to folder
        var folder = tslib_1.__assign({}, folderToBeEmptied);
        folder.FolderId = {
            Id: tableViewToBeEmptied.serverFolderId,
        };
        folder.TotalCount = tableViewToBeEmptied.totalRowsInView;
        emptyFolder(folder, getFocusedFilterForTable(tableViewToBeEmptied), getViewFilterForTable(tableViewToBeEmptied), isExplicitSoftDelete, actionSource, rowKeysToExclude, tableViewToBeEmptied.selectAllModeTimeStamp, tableViewToBeEmptied.id);
    }
}));
//# sourceMappingURL=emptyTableView.js.map